import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Platform from "@/pages/Platform";
import Framework from "@/pages/Framework";
import Lifecycle from "@/pages/Lifecycle";
import Perspective from "@/pages/Perspective";
import Engagements from "@/pages/Engagements";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Deck from "@/pages/Deck";
import Playbook from "@/pages/Playbook";
import BDHandbook from "@/pages/BDHandbook";
import Layout from "@/components/Layout";
import { AuthProvider } from "@/console/AuthContext";
import RequireAuth from "@/console/RequireAuth";
import ConsoleLogin from "@/console/ConsoleLogin";
import ConsoleEngagements from "@/console/ConsoleEngagements";
import ConsoleEngagementWorkspace from "@/console/ConsoleEngagementWorkspace";
import ConsoleRequests from "@/console/ConsoleRequests";
import ConsoleUsers from "@/console/ConsoleUsers";
import Outreach from "@/console/outreach/Outreach";
import ConsoleDemo from "@/console/demo/ConsoleDemo";
import ConsoleAnalytics from "@/console/ConsoleAnalytics";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public login — the only unauthenticated route */}
            <Route path="/login" element={<ConsoleLogin />} />
            <Route path="/console/login" element={<ConsoleLogin />} />

            {/* Public marketing site — open to anyone */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/practice" element={<Platform />} />
              <Route path="/platform" element={<Navigate to="/practice" replace />} />
              <Route path="/framework" element={<Framework />} />
              <Route path="/lifecycle" element={<Lifecycle />} />
              <Route path="/perspective" element={<Perspective />} />
              <Route path="/engagements" element={<Engagements />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Route>

            {/* Internal V2E Console */}
            <Route path="/console" element={<Navigate to="/console/engagements" replace />} />
            <Route
              path="/console/requests"
              element={
                <RequireAuth>
                  <ConsoleRequests />
                </RequireAuth>
              }
            />
            <Route
              path="/console/users"
              element={
                <RequireAuth>
                  <ConsoleUsers />
                </RequireAuth>
              }
            />
            <Route
              path="/outreach"
              element={
                <RequireAuth>
                  <Outreach />
                </RequireAuth>
              }
            />
            <Route
              path="/demo"
              element={
                <RequireAuth>
                  <ConsoleDemo />
                </RequireAuth>
              }
            />
            <Route
              path="/console/analytics"
              element={
                <RequireAuth>
                  <ConsoleAnalytics />
                </RequireAuth>
              }
            />
            <Route path="/admin/analytics" element={<Navigate to="/console/analytics" replace />} />
            <Route
              path="/console/engagements"
              element={
                <RequireAuth>
                  <ConsoleEngagements />
                </RequireAuth>
              }
            />
            <Route
              path="/console/engagements/:id"
              element={
                <RequireAuth>
                  <ConsoleEngagementWorkspace />
                </RequireAuth>
              }
            />

            {/* Corporate briefing — public, no login required so it can be shared freely */}
            <Route path="/deck" element={<Deck />} />

            {/* Client playbook — long-form scrollable guide, no public-site layout */}
            <Route
              path="/playbook"
              element={
                <RequireAuth>
                  <Playbook />
                </RequireAuth>
              }
            />

            {/* Internal BD handbook — long-form + print-optimised, no public-site layout, noindex meta */}
            <Route
              path="/bd-handbook"
              element={
                <RequireAuth>
                  <BDHandbook />
                </RequireAuth>
              }
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#111923",
            color: "#EDE9DF",
            border: "1px solid rgba(255,255,255,0.12)",
            borderRadius: 0,
            fontFamily: '"IBM Plex Sans", system-ui, sans-serif',
          },
        }}
      />
    </div>
  );
}

export default App;
